import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Subscription } from 'rxjs';

import { LayoutsService } from 'pn-core-code';

import { AppTopbarComponent } from '../app-topbar/app-topbar.component';

@Component({
  selector: 'layout-landing',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AppTopbarComponent],
  templateUrl: './layout-landing.component.html',
  styleUrl: './layout-landing.component.scss'
})
export class LayoutLandingComponent implements OnInit, OnDestroy {

  constructor(  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }
}
